export const addItem = async (ItemData) => {
    const response = await fetch(process.env.REACT_APP_API_URL, {
        method: "POST",
        body: JSON.stringify({ action: "addItems", apiKey: process.env.REACT_APP_API_KEY, origin: window.location.origin, ...ItemData })
    });
    const jsonResponse = await response.json();

    if (jsonResponse?.success === true) {
        let data = ItemData;
        data.id = jsonResponse?.data?.id;
        
        jsonResponse.data = data;
    }
    console.log('Add Item Response:', jsonResponse);
    return jsonResponse;
};
export const updateItem = async (ItemId, ItemData) => {
    const response = await fetch(process.env.REACT_APP_API_URL, {
        method: "POST",
        body: JSON.stringify({ action: "updateItems", apiKey: process.env.REACT_APP_API_KEY, origin: window.location.origin, id: ItemId, ...ItemData })
    });
    const jsonResponse = await response.json();
    if (jsonResponse?.success === true) {
        let data = ItemData;
        data.id = ItemId;
        jsonResponse.data = data;
    }
    console.log('Update Item Response:', response);
    return jsonResponse;
};
export const deleteItem = async (ItemId) => {
    const response = await fetch(process.env.REACT_APP_API_URL, {
        method: "POST",
        body: JSON.stringify({ action: "deleteItems", apiKey: process.env.REACT_APP_API_KEY, origin: window.location.origin, id: ItemId })
    });
    return await response.json();
};
